class AppContext {

    conference = null;

}

export default new AppContext();
